import packageJson from '../../package.json'

export const USER_STORAGE_KEY = "@japexpress/user";
export const TOKEN_STORAGE_KEY = "@japexpress/token";
export const GUEST_TOKEN_KEY = "@japexpress/guest-token";
export const REFERRAL_STORAGE_KEY = "@japexpress/referral-code";
export const APP_VERSION = packageJson.version;
export const SUPPORT_WHATSAPP = "5588998106859";
